// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpotForm_form-container__a3KFi{
    width: 70vw;
    min-height: 40vw;
    height: auto;
    margin-left: 15vw;
    border-radius: 2vw;
    margin-top: 5vw;
    margin-bottom: 5vw;
    display: flex;
    background: url("https://static.wixstatic.com/media/da937f_71fa99456de64f4ca0dacd3c15e0f8df~mv2.webp");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0%;
}

/* .form-bg-img{
    width: 70vw;
    min-height: 40vw;
    height: auto;
    position: absolute; 
    object-fit: cover;
    z-index: -1;
    flex-direction: row;
    border-radius: 2vw;
} */

.SpotForm_form-waiting-text__ZlA7Q{
    font-size: 3vw;
    width: 25vw;
    margin-left: 3vw;
    margin-top: 5vw;   
    font-family: dm-sans-medium;
}

.SpotForm_form-inner-container__ifRMV{
    width: 34vw;
    min-height: 30vw;
    height: auto;
    margin-left: 6.5vw;
    margin-top: 4.5vw;
    margin-bottom: 5vw;
    border-radius: 1.5vw;
    display: flex;
    flex-direction: column;
    background-color: white;
}

.SpotForm_book-spot__kxS82{
    font-size: 2.5vw;
    text-align: center;
    margin-top: 0;
    font-family: dm-sans-regular;
}

.SpotForm_form-name-input__E6PRK{
    font-size: 1.4vw;
    width: 90%;
    height: 3.2vw;
    padding-left: 1.5vw;
    padding-right: 1.5vw;
    box-sizing: border-box;
    margin-left: 5%;
    border-radius: 100vw;
    border: 2px solid black;
    margin-bottom: 1.7vw;
    font-family: dm-sans-light;
}

.SpotForm_select-date__fez-e{
    font-size: 1.2vw;
    margin-left: 5%;
    margin-top: 0vw;
    margin-bottom: 0;
    font-family: dm-sans-light;
}

.SpotForm_option-container__hk4rG{
    display: flex;
    flex-direction: column;
    margin-left: 1.5vw;
    font-size: 1.2vw;
    font-weight: 300;
    line-height: 2vw;
    margin-bottom: 1.5vw;
}

.SpotForm_trip-date-labels__5SgWS{
    cursor: pointer;
    font-family: dm-sans-light;
}

.SpotForm_trip-date-options__cH0KG{
    margin-right: 0.7vw;
    height: 1.1vw;
    width: 1.1vw;
    font-family: dm-sans-light;
}

.SpotForm_trip-form-submit__O9XMp{
    width: 50%;
    margin-left: 25%;
    height: 3.5vw;
    background-color: #e65439;
    border-radius: 100vw;
    border:none;
    color: white;
    font-weight: bold;
    font-size: 1.3vw;
    margin-bottom: 1.5vw;
    cursor: pointer;
    font-family: dm-sans-medium;
}

@media(max-width: 768px){
    .SpotForm_form-container__a3KFi{
        width: 90vw;
        min-height: 100vw;
        height: auto;
        margin-left: 5vw;
        border-radius: 5vw;
        margin-top: 5vw;
        margin-bottom: 10vw;
        display: flex;
        background: url("https://static.wixstatic.com/media/da937f_71fa99456de64f4ca0dacd3c15e0f8df~mv2.webp");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 0%;
    }
    
    .SpotForm_form-waiting-text__ZlA7Q{
        font-size: 3vw;
        width: 25vw;
        margin-left: 3vw;
        margin-top: 5vw;
        display: none;   
    }
    
    .SpotForm_form-inner-container__ifRMV{
        width: 90vw;
        min-height: 30vw;
        height: auto;
        margin-left: 0vw;
        margin-top: 0vw;
        margin-bottom: 0vw;
        border-radius: 5vw;
        display: flex;
        flex-direction: column;
        background-color: rgba(255, 255, 255, 0.438);
    }
    
    .SpotForm_book-spot__kxS82{
        font-size: 7vw;
        text-align: center;
        margin-top: 5vw;
    }
    
    .SpotForm_form-name-input__E6PRK{
        font-size: 4vw;
        width: 90%;
        height: 11vw;
        padding-left: 3vw;
        padding-right: 3vw;
        box-sizing: border-box;
        margin-left: 5%;
        border-radius: 100vw;
        border: 1px solid black;
        margin-bottom: 5vw;
    }
    
    .SpotForm_select-date__fez-e{
        font-size: 6vw;
        margin-left: 5%;
        margin-top: 0vw;
        margin-bottom: 2vw;
    }
    
    .SpotForm_option-container__hk4rG{
        /* display: flex;
        flex-direction: column;
        margin-left: 1.5vw;
        font-size: 3vw;
        font-weight: 300;
        line-height: 2vw;
        margin-bottom: 1.5vw; */
        display: flex;
        flex-direction: column;
        margin-left: 3vw;
        font-size: 4.5vw;
        font-weight: 400;
        line-height: 7vw;
        margin-bottom: 8vw;
    }
    
    .SpotForm_trip-date-labels__5SgWS{
        /* display: flex;
        flex-direction: row;
        cursor: pointer;
        height: 5vw; */
        display: flex;
        flex-direction: row;
        height: 6vw;
        margin-bottom: 2vw;
    }
    
    .SpotForm_trip-date-options__cH0KG{
        /* margin-right: 1vw; */
        /* height: auto;
        width: auto;
        align-self: center;
        justify-self: center; */
        margin-right: 2vw;
        cursor: pointer;
        align-self: center;
        justify-self: center;
        height: auto;
        width: auto;
    }
    
    .SpotForm_trip-form-submit__O9XMp{
        width: 50%;
        margin-left: 25%;
        height: 8vw;
        background-color: #e65439;
        border-radius: 100vw;
        border:none;
        color: white;
        font-weight: bold;
        font-size: 4vw;
        margin-bottom: 10vw;
        cursor: pointer;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SingleTripPage/SpotForm/SpotForm.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,sGAAsG;IACtG,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;;;;;;;GASG;;AAEH;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,oBAAoB;IACpB,uBAAuB;IACvB,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,aAAa;QACb,sGAAsG;QACtG,4BAA4B;QAC5B,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,4CAA4C;IAChD;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;QACf,oBAAoB;QACpB,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI;;;;;;+BAMuB;QACvB,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI;;;sBAGc;QACd,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB;;;+BAGuB;QACvB,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,oBAAoB;QACpB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,WAAW;QACX,yBAAyB;QACzB,oBAAoB;QACpB,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,cAAc;QACd,mBAAmB;QACnB,eAAe;IACnB;AACJ","sourcesContent":[".form-container{\n    width: 70vw;\n    min-height: 40vw;\n    height: auto;\n    margin-left: 15vw;\n    border-radius: 2vw;\n    margin-top: 5vw;\n    margin-bottom: 5vw;\n    display: flex;\n    background: url(\"https://static.wixstatic.com/media/da937f_71fa99456de64f4ca0dacd3c15e0f8df~mv2.webp\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: 0%;\n}\n\n/* .form-bg-img{\n    width: 70vw;\n    min-height: 40vw;\n    height: auto;\n    position: absolute; \n    object-fit: cover;\n    z-index: -1;\n    flex-direction: row;\n    border-radius: 2vw;\n} */\n\n.form-waiting-text{\n    font-size: 3vw;\n    width: 25vw;\n    margin-left: 3vw;\n    margin-top: 5vw;   \n    font-family: dm-sans-medium;\n}\n\n.form-inner-container{\n    width: 34vw;\n    min-height: 30vw;\n    height: auto;\n    margin-left: 6.5vw;\n    margin-top: 4.5vw;\n    margin-bottom: 5vw;\n    border-radius: 1.5vw;\n    display: flex;\n    flex-direction: column;\n    background-color: white;\n}\n\n.book-spot{\n    font-size: 2.5vw;\n    text-align: center;\n    margin-top: 0;\n    font-family: dm-sans-regular;\n}\n\n.form-name-input{\n    font-size: 1.4vw;\n    width: 90%;\n    height: 3.2vw;\n    padding-left: 1.5vw;\n    padding-right: 1.5vw;\n    box-sizing: border-box;\n    margin-left: 5%;\n    border-radius: 100vw;\n    border: 2px solid black;\n    margin-bottom: 1.7vw;\n    font-family: dm-sans-light;\n}\n\n.select-date{\n    font-size: 1.2vw;\n    margin-left: 5%;\n    margin-top: 0vw;\n    margin-bottom: 0;\n    font-family: dm-sans-light;\n}\n\n.option-container{\n    display: flex;\n    flex-direction: column;\n    margin-left: 1.5vw;\n    font-size: 1.2vw;\n    font-weight: 300;\n    line-height: 2vw;\n    margin-bottom: 1.5vw;\n}\n\n.trip-date-labels{\n    cursor: pointer;\n    font-family: dm-sans-light;\n}\n\n.trip-date-options{\n    margin-right: 0.7vw;\n    height: 1.1vw;\n    width: 1.1vw;\n    font-family: dm-sans-light;\n}\n\n.trip-form-submit{\n    width: 50%;\n    margin-left: 25%;\n    height: 3.5vw;\n    background-color: #e65439;\n    border-radius: 100vw;\n    border:none;\n    color: white;\n    font-weight: bold;\n    font-size: 1.3vw;\n    margin-bottom: 1.5vw;\n    cursor: pointer;\n    font-family: dm-sans-medium;\n}\n\n@media(max-width: 768px){\n    .form-container{\n        width: 90vw;\n        min-height: 100vw;\n        height: auto;\n        margin-left: 5vw;\n        border-radius: 5vw;\n        margin-top: 5vw;\n        margin-bottom: 10vw;\n        display: flex;\n        background: url(\"https://static.wixstatic.com/media/da937f_71fa99456de64f4ca0dacd3c15e0f8df~mv2.webp\");\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 0%;\n    }\n    \n    .form-waiting-text{\n        font-size: 3vw;\n        width: 25vw;\n        margin-left: 3vw;\n        margin-top: 5vw;\n        display: none;   \n    }\n    \n    .form-inner-container{\n        width: 90vw;\n        min-height: 30vw;\n        height: auto;\n        margin-left: 0vw;\n        margin-top: 0vw;\n        margin-bottom: 0vw;\n        border-radius: 5vw;\n        display: flex;\n        flex-direction: column;\n        background-color: rgba(255, 255, 255, 0.438);\n    }\n    \n    .book-spot{\n        font-size: 7vw;\n        text-align: center;\n        margin-top: 5vw;\n    }\n    \n    .form-name-input{\n        font-size: 4vw;\n        width: 90%;\n        height: 11vw;\n        padding-left: 3vw;\n        padding-right: 3vw;\n        box-sizing: border-box;\n        margin-left: 5%;\n        border-radius: 100vw;\n        border: 1px solid black;\n        margin-bottom: 5vw;\n    }\n    \n    .select-date{\n        font-size: 6vw;\n        margin-left: 5%;\n        margin-top: 0vw;\n        margin-bottom: 2vw;\n    }\n    \n    .option-container{\n        /* display: flex;\n        flex-direction: column;\n        margin-left: 1.5vw;\n        font-size: 3vw;\n        font-weight: 300;\n        line-height: 2vw;\n        margin-bottom: 1.5vw; */\n        display: flex;\n        flex-direction: column;\n        margin-left: 3vw;\n        font-size: 4.5vw;\n        font-weight: 400;\n        line-height: 7vw;\n        margin-bottom: 8vw;\n    }\n    \n    .trip-date-labels{\n        /* display: flex;\n        flex-direction: row;\n        cursor: pointer;\n        height: 5vw; */\n        display: flex;\n        flex-direction: row;\n        height: 6vw;\n        margin-bottom: 2vw;\n    }\n    \n    .trip-date-options{\n        /* margin-right: 1vw; */\n        /* height: auto;\n        width: auto;\n        align-self: center;\n        justify-self: center; */\n        margin-right: 2vw;\n        cursor: pointer;\n        align-self: center;\n        justify-self: center;\n        height: auto;\n        width: auto;\n    }\n    \n    .trip-form-submit{\n        width: 50%;\n        margin-left: 25%;\n        height: 8vw;\n        background-color: #e65439;\n        border-radius: 100vw;\n        border:none;\n        color: white;\n        font-weight: bold;\n        font-size: 4vw;\n        margin-bottom: 10vw;\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form-container": `SpotForm_form-container__a3KFi`,
	"form-waiting-text": `SpotForm_form-waiting-text__ZlA7Q`,
	"form-inner-container": `SpotForm_form-inner-container__ifRMV`,
	"book-spot": `SpotForm_book-spot__kxS82`,
	"form-name-input": `SpotForm_form-name-input__E6PRK`,
	"select-date": `SpotForm_select-date__fez-e`,
	"option-container": `SpotForm_option-container__hk4rG`,
	"trip-date-labels": `SpotForm_trip-date-labels__5SgWS`,
	"trip-date-options": `SpotForm_trip-date-options__cH0KG`,
	"trip-form-submit": `SpotForm_trip-form-submit__O9XMp`
};
export default ___CSS_LOADER_EXPORT___;
